import { findAllJobPostDto, findAllJobPostResponse, findJobDescriptionByIdResponse, JobPosition } from "../Interface/Index";
import apiClient from "./api-client.service";

export default class JobDescriptionService {
  private static instance: JobDescriptionService;
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  static getInstance(): JobDescriptionService {
    if (!JobDescriptionService.instance) {
      JobDescriptionService.instance = new JobDescriptionService();
    }
    return JobDescriptionService.instance;
  }

  async findAllJobPostWithFiletrsAndPositionCounts(payload: findAllJobPostDto): Promise<findAllJobPostResponse> {
    const { page, limit, position, searchQuery } = payload;
    try {
      let url = `${this.APIBaseUrl}/job-description`;

      if (page && limit) {
        url += `?page=${page}&limit=${limit}`;
      }

      if (position && position.length > 0) {
        url += `&positions=${position.join(',')}`;
      }

      if (searchQuery) {
        url += `&search=${searchQuery}`;
      }

      const response = await apiClient.get(url);
      return response.data;
    } catch (error) {
      console.error("Error fetching job posts:", error);
      throw error;
    }
  }

  async findJobDescriptionById(id: string): Promise<findJobDescriptionByIdResponse> {
    try{
      const response = await apiClient.get(
        `${this.APIBaseUrl}/job-description/${id}`
      );
      console.log("🚀 ~ JobDescriptionService ~ findJobDescriptionById ~ response:", response)
      return response.data;
    }catch(error){
      console.error("Error fetching job description by id:", error);
      throw new Error("Failed to fetch job description");
    }
  }
}
